import React, { useContext, Suspense } from 'react';
import DynamicLayout from '../components/DynamicLayout';
import { PlatformContext } from '../context/PlatformContext';
import { MobileComponents, DesktopComponents, LoadingComponent } from '../helpers/platformUtils';
import ProfileComponent from '../components/ProfileComponent';
import NoIndexHelmet from '../components/NoIndexHelmet';

const Account = () => {
  const { platform, loading } = useContext(PlatformContext);
  
  if (loading) {
    return (
      <DynamicLayout>
        <NoIndexHelmet title="Account | Saturnalia" />
        <LoadingComponent />
      </DynamicLayout>
    );
  }

  const isMobile = platform === 'mobileApp' || platform === 'mobileWeb';
  const MobileComponent = MobileComponents.Account;
  const DesktopComponent = ProfileComponent;

  return (
    <DynamicLayout>
      <NoIndexHelmet title="Account | Saturnalia" />
      <Suspense fallback={<LoadingComponent />}>
        {isMobile ? (
          <MobileComponent />
        ) : (
          <div
            className="full-screen-image-container margin-top-0"
            style={{
              backgroundImage: 'linear-gradient(165deg, #3a0f1d 0%, #2b0b16 45%, #1a060c 100%)',
            }}
          >
            <DesktopComponent />
          </div>
        )}
      </Suspense>
    </DynamicLayout>
  );
};

export default Account;
